// redux/prefs/prefsSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { currencies, DEFAULT_CURRENCY } from "../../constants/default";
import { SUPPORTED_LOCALES } from "../../constants/locales";

const initialState = {
  lang: "en",
  cur: DEFAULT_CURRENCY,
  residency: null,
  langManuallySet: false,
  curManuallySet: false,
};

const prefsSlice = createSlice({
  name: "prefs",
  initialState,
  reducers: {
    setPrefs: (state, action) => {
      // console.log(`in setPrefs: ${JSON.stringify(action)}`)
      const newState = { ...state, ...action.payload };
      
      // Validate currency if present
      if (newState.cur) {
        // Handle array case (from URL params) - take the latest value
        let currency = Array.isArray(newState.cur) ? newState.cur[newState.cur.length - 1] : newState.cur;
        currency = currency.toUpperCase();
        
        if (!currencies.includes(currency)) {
          console.log(`currency ${currency} is not supported. Fallback to ${DEFAULT_CURRENCY}`);
          currency = DEFAULT_CURRENCY; // fallback currency - consistent with initial state
        }
        newState.cur = currency;
      }

      // Validate language if present
      if (newState.lang) {
        // Handle array case (from URL params) - take the latest value
        let lang = Array.isArray(newState.lang) ? newState.lang[newState.lang.length - 1] : newState.lang;
        lang = String(lang).toLowerCase();

        if (!SUPPORTED_LOCALES.includes(lang)) {
          console.log(`language ${lang} is not supported. Fallback to ${initialState.lang}`);
          lang = initialState.lang;
        }
        newState.lang = lang;
      }
      
      return newState;
    },
    updatePrefsRequest: (state, action) => {
      // Optionally mark "loading" here
    },
    loadPrefsRequest: (state, action) => {
      // Trigger loading preferences from backend
    },
  },
});

export const { setPrefs, updatePrefsRequest, loadPrefsRequest } = prefsSlice.actions;
export default prefsSlice.reducer;
